export const IconTechnicians = ({
  width = 35,
  height = 24,
  color = 'white',
  rotation = 0,
}) => (
  <svg
    width='32'
    height='33'
    viewBox='0 0 32 33'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <mask
      id='mask0_15669_31954'
      maskUnits='userSpaceOnUse'
      x='0'
      y='0'
      width='32'
      height='33'
    >
      <rect y='0.5' width='32' height='32' fill='#D9D9D9' />
    </mask>
    <g mask='url(#mask0_15669_31954)'>
      <path
        d='M24.6206 28.4666C24.4768 28.4666 24.3443 28.443 24.2229 28.3959C24.1016 28.349 23.9828 28.2675 23.8666 28.1513L17.2206 21.5306C17.1042 21.4144 17.0225 21.2956 16.9756 21.1743C16.9285 21.0529 16.9049 20.9205 16.9049 20.7769C16.9049 20.6334 16.9285 20.5008 16.9756 20.3793C17.0225 20.2579 17.1042 20.1391 17.2206 20.0229L19.4383 17.8049C19.5545 17.6887 19.6734 17.6071 19.7949 17.5603C19.9163 17.5131 20.0487 17.4896 20.1923 17.4896C20.3358 17.4896 20.4683 17.5131 20.5896 17.5603C20.7109 17.6071 20.8297 17.6887 20.9459 17.8049L27.5923 24.4513C27.7085 24.5675 27.7902 24.6863 27.8373 24.8076C27.8842 24.9289 27.9076 25.0614 27.9076 25.2049C27.9076 25.3487 27.8842 25.4813 27.8373 25.6026C27.7902 25.7239 27.7085 25.8427 27.5923 25.9589L25.3743 28.1513C25.258 28.2675 25.1393 28.349 25.0179 28.3959C24.8966 28.443 24.7642 28.4666 24.6206 28.4666ZM24.6206 27.0693L26.4846 25.2049L20.1999 18.9206L18.3359 20.7846L24.6206 27.0693ZM7.34594 28.4743C7.20238 28.4743 7.06871 28.4495 6.94494 28.3999C6.82094 28.3504 6.70082 28.2675 6.5846 28.1513L4.37427 25.9666C4.25805 25.8504 4.17516 25.7303 4.1256 25.6063C4.07605 25.4825 4.05127 25.3487 4.05127 25.2049C4.05127 25.0614 4.07605 24.9247 4.1256 24.7949C4.17516 24.6649 4.25805 24.5418 4.37427 24.4256L11.2359 17.5639H14.0179L15.0486 16.5333L9.39494 10.8793H7.49494L4.12827 7.51259L6.9716 4.66926L10.3383 8.03592V9.93592L15.9923 15.5896L20.0126 11.5693L17.5539 9.11026L19.0616 7.60259H16.0383L15.4896 7.07926L19.2743 3.29492L19.7973 3.81792V6.86659L21.3049 5.35892L26.6026 10.6049C26.929 10.9145 27.1709 11.2697 27.3283 11.6706C27.4854 12.0713 27.5639 12.4956 27.5639 12.9436C27.5639 13.2718 27.5153 13.5906 27.4179 13.8999C27.3204 14.2093 27.1768 14.5016 26.9873 14.7769L24.2563 12.0459L22.3639 13.9383L20.9383 12.5126L14.9359 18.5153V21.3409L8.09994 28.1513C7.98371 28.2675 7.86494 28.3504 7.7436 28.3999C7.62227 28.4495 7.48971 28.4743 7.34594 28.4743ZM7.34594 27.0436L13.9103 20.4793V18.6153H12.0459L5.48194 25.1793L7.34594 27.0436ZM7.34594 27.0436L5.48194 25.1793L6.41794 26.1076L7.34594 27.0436Z'
        fill='#121926'
      />
    </g>
  </svg>
);
